import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js'
import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js'
import SnippetsIndex from 'trunks/vue/admin/components/templates/snippets_index.js'
import SnippetForm from 'trunks/vue/admin/components/templates/snippet_form.js'

function parsePayload(element, key) {
  if (!element) return {}
  return JSON.parse(element.dataset[key] || '{}')
}

class Admin__Cms__SnippetsController extends Skylark.App.BaseController {
  index() {
    this._generateSettingsSidebarView('settings__templates')
    const container = DomMaster.find('#js-cms-snippets-index').node
    if (!container) return

    new SnippetsIndex({
      el: container,
      propsData: {
        snippetsData: parsePayload(container, 'snippets')
      }
    })
  }

  new() {
    this._generateSettingsSidebarView('settings__templates')
    this._generateSnippetForm('new')
  }

  show() {
    this._generateSettingsSidebarView('settings__templates')
    this._generateSnippetForm('edit')
  }

  _generateSnippetForm(mode) {
    const container = DomMaster.find('#js-cms-snippet-form').node
    if (!container) return

    new SnippetForm({
      el: container,
      propsData: {
        mode: container.dataset.mode || mode,
        formData: parsePayload(container, 'snippet')
      }
    })
  }
}

Admin__Cms__SnippetsController.include(GenerateMorePopover, SettingsNavigator)

export default Admin__Cms__SnippetsController
